import React, { useState } from "react";
import PropTypes from "prop-types";
import Highlighter from "react-highlight-words";
import axios from "axios";
import { debounce } from "lodash";
import useIsSsr from "./UseIsSsr";
import getEncodedURI from "./getEncodedURI";

const GlobalSearch = ({ searchUrl, inputValue }) => {
  const isSsr = useIsSsr();
  const searchParams = isSsr ? "" : window.location.search;
  const queryParams = new URLSearchParams(searchParams);
  const [searchValue, setSearchValue] = useState(inputValue || "");
  const [hints, setHints] = useState([]);

  const fetchHints = (value) => {
    axios
      .get(`${searchUrl}.json?q=${value}`)
      .then((res) => {
        setHints(res.data);
      })
      .catch(() => {
        setHints([]);
      });
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);
    if (value.length < 3) {
      setHints([]);
      return;
    }
    queryParams.set("q", value);
    debounce(fetchHints, 300)(value);
  };

  const handleInputPress = ({ key }) => {
    if (key !== "Enter") return;
    const newQuery = getEncodedURI(searchValue);
    window.location.href = `${searchUrl}?q=${newQuery}`;
  };

  const renderHints = () =>
    hints.map((item) => (
      <React.Fragment key={JSON.stringify(item)}>
        {item.lessons.map((lesson) => (
          <React.Fragment key={JSON.stringify(lesson)}>
            {lesson && (
              <a href={lesson.url}>
                <div className="main__hint">
                  <Highlighter
                    highlightClassName="main__hint-matches"
                    className="main__hint-name"
                    searchWords={[searchValue]}
                    textToHighlight={lesson.name}
                  />
                  <div className="main__hint-dot" />
                  <Highlighter
                    highlightClassName="main__hint-matches"
                    className="main__hint-topic"
                    searchWords={[searchValue]}
                    textToHighlight={item.course.name}
                  />
                </div>
              </a>
            )}
          </React.Fragment>
        ))}
      </React.Fragment>
    ));

  return (
    <section className="main__search-wr">
      <div className="main__search">
        <input
          value={searchValue}
          onChange={handleInputChange}
          onKeyPress={handleInputPress}
          type="text"
          className="main__search-input"
          placeholder="Поиск по темам и урокам"
        />
      </div>
      {hints.length !== 0 && <div className="main__hints">{renderHints()}</div>}
    </section>
  );
};

GlobalSearch.propTypes = {
  searchRes: PropTypes.array,
  searchUrl: PropTypes.string,
  inputValue: PropTypes.string,
};

export default GlobalSearch;



// WEBPACK FOOTER //
// ./app/frontend/components/GlobalSearch.js